export const colors = {
  brand: {
    text: '#8BF5F2',
    200: '#BBFFFD',
    300: '#AF3065',
    400: '#C21919',
    500: '#108FEF',
    600: '#B1B4B5',
    700: '#C7CBD4',
    800: '#60DFDB',
    900: '#555D6D',
    1000: '#F0F3F5',
    1100: '#666666',
    1200: '#64D8C5',
    1300: '#FFFFFF',
    1400: '#000000',
    1500: '#EFEFEF',
    1600: '#C0EC97',
    1700: '#FFA7A7',
    1800: '#FEE586',
    1900: '#ABDBFF',
    2000: '#EDD2FF',
    2100: '#43A837',
    2200: '#F3980F',
    2300: '#FFC7CE',
    2400: '#F568C1',
    2600: '#a0a1a5',
    2700: '#2BDC2B',
    2800: '#ffe433',
    2900: '#f33',
    3000: '#FFE2E2',
    3100: '#dedede',
    // New Colors from refact
    primary: '#7C2159',
    secondary: '#60DFDB',
    tertiary500: '#B23B85',
    tertiary: '#7E225A',
    warning: 'rgba(255, 12, 12, 0.05);',
    tangerine: '#FFAE14',
    tangerine100: '#FFA078',
    tangerine500: '#FA5F1D',
    white: '#fff',
    white100: '#F2F5F8',
    white200: '#F2F2F2',
    white300: '#f7f7f7',
    grey: '#F2F2F2',
    gray: '#E9EBEE',
    gray50: '#E9E9E9',
    gray100: '#CCD1D6',
    gray150: '#bfbfbf',
    gray200: '#ACB4BA',
    gray300: '#737D86',
    gray400: '#5A646E',
    gray500: '#6B6B6B',
    gray550: '#666666',
    gray600: '#22272D',
    gray700: '#3B454F',
    black700: '#050505',
    blue300: '#63B3ED',
    blue500: '#0094ff',
    red100: '#EE4953',
    red200: '#FF0C0C',
    green100: '#24B04B',
    green500: '#03c02c',
    magenta: '#027773',
    magenta300: '#28BAB5',
    purple: '#B83EE3',
  },
};
